import { AdminPagesStateModel } from "../../admin.state";
import { Message } from "../models/message.interface";

export class MessagesStateModel extends AdminPagesStateModel {
  items: Message[];
  totalCount: number;
}
